export default "__VITE_ASSET__i7b33On5__"